import React from 'react';
import { SALON_NAME } from '../../services/api';
import { fmtDate } from '../../utils/dates';
import { formatMoney, paidTotal } from '../../utils/money';

/** The printed / WhatsApp invoice. Plain markup so printReceipt() can copy it into a print frame. */
export default function Receipt({ bill }) {
  const inv = bill.invoice || {};
  const when = inv.created_at || bill.updated_at || bill.created_at;
  return (
    <div className="dp-receipt" id="dp-receipt">
      <div className="rc-brand">
        <div className="rc-mark">{SALON_NAME.slice(0, 1)}</div>
        <div>
          <h2>{SALON_NAME}</h2>
          <p>{bill.franchise_name || 'Salon'} · Tax invoice</p>
        </div>
      </div>
      <div className="rc-meta">
        <div>
          <span>Invoice</span>
          <strong>{inv.invoice_number || '—'}</strong>
        </div>
        <div>
          <span>Date</span>
          <strong>{fmtDate(when)}</strong>
        </div>
        <div>
          <span>Guest</span>
          <strong>{bill.customer?.name || 'Guest'}</strong>
        </div>
        <div>
          <span>Mobile</span>
          <strong>{bill.customer?.phone || '—'}</strong>
        </div>
        <div>
          <span>Confirmed by</span>
          <strong>{bill.manager_name || '—'}</strong>
        </div>
        <div>
          <span>Paid</span>
          <strong>{formatMoney(paidTotal(bill))}</strong>
        </div>
      </div>
      <table className="rc-table">
        <thead>
          <tr>
            <th>Service</th>
            <th className="num">Qty</th>
            <th className="num">Price</th>
            <th className="num">Amount</th>
          </tr>
        </thead>
        <tbody>
          {(bill.items || []).map((it) => (
            <tr key={it.id}>
              <td>
                {it.name}
                {it.stylist_name ? <div className="rc-sub">Stylist: {it.stylist_name}</div> : null}
              </td>
              <td className="num">{it.quantity}</td>
              <td className="num">{formatMoney(it.unit_price)}</td>
              <td className="num">{formatMoney(it.line_total)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={3}>Subtotal</td>
            <td className="num">{formatMoney(bill.subtotal)}</td>
          </tr>
          {Number(bill.discount_amount) > 0 ? (
            <tr>
              <td colSpan={3}>{bill.discount_label || 'Discount'}</td>
              <td className="num">− {formatMoney(bill.discount_amount)}</td>
            </tr>
          ) : null}
          <tr>
            <td colSpan={3}>Tax ({Math.round((Number(bill.tax_rate) || 0) * 100)}%)</td>
            <td className="num">{formatMoney(bill.tax_amount)}</td>
          </tr>
          <tr className="rc-grand">
            <td colSpan={3}>Grand total</td>
            <td className="num">{formatMoney(bill.grand_total)}</td>
          </tr>
        </tfoot>
      </table>
      <p className="rc-foot">Thank you for visiting {SALON_NAME}.</p>
    </div>
  );
}
